<template>
  <div class="project-trials-list">
    <div class="trial-list-header">
      <!--<div class="button button-filter">Filter</div>-->
      <div class="filter-function" v-if="hasTrials">
        <multi-select-component
            mode="single"
            v-model="trialStatusFilterValue"
            :label="$t('show_projects')"
            :options="trialStatusFilterOptions"
            :configurationOptions="{ 'allow-empty': false, 'label-inside': true }"
          />
      </div>
      <div class="sort-function" v-if="hasTrials">
        <multi-select-component
          mode="single"
          v-model="sortingValue"
          :label="$t('sort_by')"
          :options="sortingOptions"
          :configurationOptions="{ 'allow-empty': false, 'label-inside': true }"
        />
        <!-- <select v-model="sortingValue">
          <option
            v-for="option in sortingOptions"
            v-bind:value="option.value"
            v-bind:key="option.value"
          >{{ option.text }}</option>
        </select>-->
        <div
          class="sort-arrow down"
          :class="sortingDirection === 'down' ? 'selected' : 'unselected'"
          @click="sortingDirection = 'down'"
        ></div>
        <div
          class="sort-arrow up"
          :class="sortingDirection === 'up' ? 'selected' : 'unselected'"
          @click="sortingDirection = 'up'"
        ></div>
        <toggle-button
            class="baseline-toggle" 
            :class="{disabled: baselinesAreIncluded || loadingBaselines}"
            color="#fd204f"
            :height=28
            :width=110
            :labels="{checked: baselinesAreIncluded ? 'Baselines Added' : 'Adding Baselines', unchecked: 'No Baselines'}"
            :value="baselinesAreIncluded"
            @change="modifyBaselinesToAdd"
          />
          <div v-if="loadingBaselines" class="loading-icon"></div>
      </div>
      <div class="buttons-new-trial">
        <div v-if="project.scenario === 'cardiosafe'" class="btn-rounded button-new-trial" @click="goToGenerateMultipleTrialsView">
          <div class="add-icon"></div>{{$t('multiple_trials')}}
        </div>
        <div class="btn-rounded button-new-trial" @click="promptNewTrial">
          <div class="add-icon"></div>{{$t('single_trial')}}
        </div>
      </div>
    </div>
    <div class="trials-list" v-if="hasTrials">
      <project-trials-list-item
        v-for="trial in sortedTrials"
        :trial="trial"
        :key="trial.id"
        @duplicate="()=>onDuplicate(trial)"
        @download="onDownload(trial)"
      ></project-trials-list-item>
      <div class="no-trials" v-if="sortedTrials.length == 0">
        {{$t('no_trials_selection')}}
      </div>
    </div>
    <div v-else>
      <div class="no-trials">
        {{$t('no_trials')}}
      </div>
    </div>
    <modal-create-new name="new-trial-modal" type="trial" :parentProject="project"></modal-create-new>
    <modal-run-trial name="run-trial" @run="runTrial"></modal-run-trial>
    <modal-create-new name="duplicate-trial-modal" type="trial_duplicate" :parentProject="project"></modal-create-new>
    <v-dialog />
  </div>
</template>

<script>
import ProjectTrialsListItem from '@/components/project/ProjectTrialsListItem'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import ModalCreateNew from '@/components/modals/ModalCreateNew'
import ModalRunTrial from '@/components/modals/ModalRunTrial'
import Api from '@/api'
import {ToggleButton} from 'vue-js-toggle-button'
import LoadingOverlay from '@/components/commons/LoadingOverlay'

const STATUS_SORTING_ORDER = [ 'ready', 'running', 'paused', 'finished', 'aborted', 'cancelled']
export default {
  name: 'ProjectDescriptionTab',
  props: ['project'],
  components: { ProjectTrialsListItem, MultiSelectComponent, ModalCreateNew, ModalRunTrial, ToggleButton, LoadingOverlay},
  data () {
    return {
      trialStatusFilterValue: '',
      sortingValue: 'creationTimestamp',
      sortingDirection: 'down',
      sortingOptions: [
        { label: 'Date', value: 'creationTimestamp' },
        { label: 'Status', value: 'status' },
        { label: 'Number of subjects', value: 'numberOfSubjects' }
      ],
      trialStatusFilterOptions: [
        { label: 'All', value: ''},
        { label: 'Draft', value: 'draft'},
        { label: 'Ready', value: 'ready'},
        { label: 'Running', value: 'running'},
        { label: 'Finished', value: 'finished'},
        { label: 'Cancelled', value: 'cancelled'},
        { label: 'Aborted', value: 'aborted'},
      ],
      loadingBaselines: false
    }
  },
  methods: {
    goToGenerateMultipleTrialsView () {
      this.$router.push(`/project/${this.project.id}/generate`)
    },
    promptNewTrial () {
      this.$modal.show('new-trial-modal')
    },
    runTrial(trial){
      if(trial.status !== 'ready'){
        Api.setTrialStatus(trial,'ready').then(()=>{
          console.log("trial status udpated!!")
        })
      }
    },
    sortingFcn (a,b) {
      let ascOrder = a - b
      if (this.sortingValue === 'creationTimestamp') {
        if (a.creationTimestamp < b.creationTimestamp) {
          ascOrder = 1
        } else if (a.creationTimestamp > b.creationTimestamp){
          ascOrder = -1
        } else {
          ascOrder = 0
        }
      } else if (this.sortingValue === 'status') {
        ascOrder = STATUS_SORTING_ORDER.findIndex(s => s === a[this.sortingValue]) - STATUS_SORTING_ORDER.findIndex(s => s === b[this.sortingValue])
      } else if (this.sortingValue === 'numberOfSubjects') {
        ascOrder = b.cohortGeneration.numberOfSubjects - a.cohortGeneration.numberOfSubjects
      }
      if (ascOrder === 0) { // perque lordre sigui alfabetic del nom en cas d'empat
        ascOrder = a.name < b.name ? -1:1
      }
      if (this.sortingDirection === 'down') return ascOrder
      return - ascOrder
    },
    onDownload(trial) {
      Api.getTrialCases(this.project.id, trial.id)
    },
    onDuplicate(trial){
      this.$modal.show('duplicate-trial-modal',{trial})
    },
    modifyBaselinesToAdd () {
      this.loadingBaselines = true
      Api.getProjectBaselines(this.project.id, this.populations).then(r => {
        this.loadingBaselines = false
        window.location.reload()
      })
    }
  },
  computed: {
    sortedTrials () {
      let currentFilter = this.trialStatusFilterValue
      if (this.project.trials){
        return this.project.trials.sort((a, b) => this.sortingFcn(a, b)).filter(trial => {
          return !currentFilter || trial.status == currentFilter
        })
      } 
      return []
    },
    hasTrials() {
      return this.project.trials && this.project.trials.length > 0
    },
    baselinesAreIncluded () {
      return this.$store.state.paramsData.project.baselinesAreIncluded
    },
    populations () {
      let trialsPopulations = this.project.trials.map(trial => {
        let popName = trial.cohortGeneration.population.parameters[0].value.flat()
        let popSize = trial.cohortGeneration.numberOfSubjects
        return [popName[0], popSize]
      })
      return Array.from(new Set(trialsPopulations.map(JSON.stringify)), JSON.parse)
    }
  }
}
</script>

<style lang="stylus" scoped>
.project-trials-list
  display: flex
  flex: 1 1 0%
  flex-direction: column

  .trial-list-header
    align-items: center
    display: flex
    flex: 0 0 60px

    .button-filter
      margin-right: 15px
    .filter-function
      margin-right: 20px
      min-width 120px
    .sort-function
      align-items: center
      display: flex
      .sort-arrow
        background-image: url("~@/assets/icons/icon-arrow.svg")
        background-position: center center
        background-repeat: no-repeat
        background-size: contain
        height: 15px
        margin-left: 5px
        transform-origin: center center
        transition: transform 0.25s ease-in-out
        width: @height

        &.up
          transform: rotate(180deg)

        &.unselected
          cursor: pointer
          opacity: 0.3
          &:hover
            opacity: 0.3
            opacity: 1
      .baseline-toggle
        margin-left: 10px
        &.disabled
          pointer-events: none

      .loading-icon
        animation: sk-scaleout 1.5s infinite ease-in-out
        background-color: gray
        align-items: center
        border-radius: 100%
        margin-left: 5px
        height: 30px
        width: 30px
    .buttons-new-trial
      display: flex
      margin-left: auto
      flex-direction: row
      .button-new-trial
        margin-left: 6px
        .add-icon
          m-icon("add-red", 22)
          margin-right 6px
        +m-breakpoint(sm md)
          display none

  .trials-list
    flex: 1 1 0%
    overflow-y: auto
  .no-trials
    m-font-size(16,18)

  @keyframes sk-scaleout
    0%
      transform: scale(0)

    100%
      opacity: 0
      transform: scale(1)
</style>
